export const transformToNumber = (value: unknown): number | undefined => {
  if (typeof value === 'number') {
    return value;
  }
  if (value) {
    return Number(value);
  }
  return undefined;
};

// 일반 이메일 형식
export const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

// 외부 관리자 이메일 형식 (일반 이메일 + Microsoft 365 External User 포함)
// 일반: pipo36@naver.com
// 외부: test_user_kt.com#EXT#@ktgroup365.onmicrosoft.com
export const EXTERNAL_MANAGER_EMAIL_REGEX =
  /^[a-zA-Z0-9._%+-]+(_[a-zA-Z0-9._-]+(#EXT#)?)?@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
